import { render } from "../templates/edit-question.html?vue&type=template&id=0203d4e2"
import script from "./edit-question.vue?vue&type=script&lang=js"
export * from "./edit-question.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__